import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandPage from './land.js';  // Ensure you have this component for the landing page
import MainPage from './main.js';
import PeoplePage from './people.js';

const App = () => {
  return (
    <Router>  {/* Ensure the entire app is wrapped inside Router */}
      <Routes>  {/* Use Routes instead of Switch */}
        <Route path="/" element={<LandPage />} /> {/* Landing Page route */}
        <Route path="/main" element={<MainPage />} />  {/* MainPage route */}
        <Route path="/people" element={<PeoplePage />} />  {/* PeoplePage route */}
      </Routes>
    </Router>
  );
};

export default App;
